import { motion } from 'framer-motion';
import { ArrowRight, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TranslatedText } from '@/components/TranslatedText';
import { DottedSurface } from '@/components/ui/dotted-surface';

export const LightHeroSection = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 bg-background overflow-hidden">
      <DottedSurface />
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-[26px] leading-[1.15] sm:text-4xl md:text-5xl lg:text-[54px] font-bold text-foreground tracking-tight"
        >
          <TranslatedText>Build a Profitable Online Business Without Showing Your Face</TranslatedText>
        </motion.h1>

        {/* Subline */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-5 sm:mt-7 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-lg mx-auto"
        >
          <TranslatedText>A university-level digital academy with 5 complete programs, 50 modules, and 500+ video lessons — all powered by AI.</TranslatedText>
        </motion.p>

        {/* Single CTA */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8 sm:mt-10 flex flex-col items-center gap-4"
        >
          <Button
            onClick={scrollToPricing}
            size="lg"
            className="w-full sm:w-auto bg-primary hover:bg-primary/90 active:scale-[0.98] text-primary-foreground text-base font-semibold h-14 rounded-xl shadow-lg shadow-primary/20 transition-all px-10"
          >
            <TranslatedText>Get Started</TranslatedText>
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>

          <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
            <Shield className="w-4 h-4 text-green-500 flex-shrink-0" />
            <span><TranslatedText>7-day money-back guarantee</TranslatedText></span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LightHeroSection;
